import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "row mb-3" }
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "col-md-5" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = ["data-number"]
const _hoisted_24 = { class: "d-flex" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "row mb-3" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = { class: "form-check form-check-inline" }
const _hoisted_33 = { class: "form-check form-check-inline" }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = { class: "form-check" }
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = { class: "form-check" }
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = { class: "form-check" }
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = { class: "form-check" }
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = { class: "form-check form-check-inline" }
const _hoisted_46 = { class: "form-check form-check-inline" }
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = { class: "mb-3" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "form-check" }
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "form-check" }
const _hoisted_55 = { class: "mb-3" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-md-4" }
const _hoisted_58 = { class: "form-check" }
const _hoisted_59 = { class: "col-md-4" }
const _hoisted_60 = { class: "form-check" }
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = { class: "mb-3" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "form-check" }
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = { class: "form-check" }
const _hoisted_68 = { class: "mb-3" }
const _hoisted_69 = { class: "form-group" }
const _hoisted_70 = { class: "row mb-4" }
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "form-group" }
const _hoisted_75 = { class: "mb-3" }
const _hoisted_76 = { class: "product-upload mb-10" }
const _hoisted_77 = { class: "dz-message needsclick" }
const _hoisted_78 = {
  key: 0,
  class: "default-image-container"
}
const _hoisted_79 = ["src"]
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_83 = {
  key: 1,
  class: "fas fa-save me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_PDFGeneratorSimple = _resolveComponent("PDFGeneratorSimple")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
        _createElementVNode("h5", { class: "mb-0" }, "FORMULAIRE DE RECENSEMENT DES MARCHANDS DE DANTOKPA")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack())),
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
        }, [...(_cache[19] || (_cache[19] = [
          _createElementVNode("i", { class: "flaticon-arrow-left position-relative ms-5 fs-12" }, null, -1),
          _createTextVNode(" Retour ", -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[62] || (_cache[62] = _createElementVNode("div", { class: "form-header" }, [
        _createElementVNode("h2", { class: "mb-0 text-white" }, "FICHE DE RECENSEMENT DES MARCHANDS DE DANTOKPA")
      ], -1)),
      _createVNode(_component_Form, {
        ref: "recensementForm",
        onSubmit: _ctx.soumettre,
        "validation-schema": _ctx.recensementSchema
      }, {
        default: _withCtx(() => [
          _cache[60] || (_cache[60] = _createElementVNode("div", { class: "section-title" }, [
            _createElementVNode("i", { class: "fas fa-user-tie me-2" }),
            _createTextVNode("Informations de l'Agent Recenseur ")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                  _createTextVNode(" Nom et Prénoms de l'agent recenseur "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "nomPrenomAgent",
                  readonly: "",
                  modelValue: _ctx.nomPrenomAgent,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nomPrenomAgent) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Nom et prénoms de l'agent recenseur"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "nomPrenomAgent",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                  _createTextVNode(" Téléphone "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "telephoneAgent",
                  readonly: "",
                  modelValue: _ctx.telephoneAgent,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telephoneAgent) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Téléphone de l'agent"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "telephoneAgent",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _cache[61] || (_cache[61] = _createElementVNode("div", { class: "section-title" }, [
            _createElementVNode("i", { class: "fas fa-store me-2" }),
            _createTextVNode("Informations du Marchand ")
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                  _createTextVNode(" Nom du marchand "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "nomMarchand",
                  modelValue: _ctx.nomMarchand,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nomMarchand) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Nom du marchand"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "nomMarchand",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                  _createTextVNode(" Prénom(s) du marchand "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "prenomMarchand",
                  modelValue: _ctx.prenomMarchand,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prenomMarchand) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Prénom(s) du marchand"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "nomPrenomMarchand",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Téléphone ", -1)),
                _createVNode(_component_Field, {
                  name: "telephoneMarchand",
                  modelValue: _ctx.telephoneMarchand,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telephoneMarchand) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Téléphone du marchand"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "telephoneMarchand",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Numéro Personnel d'Identification (NPI) ", -1)),
                _createVNode(_component_Field, {
                  name: "npi",
                  modelValue: _ctx.npi,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.npi) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "+ copie physique requise"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "npi",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                  _createTextVNode(" Secteur d'activité "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "secteurActivite",
                  modelValue: _ctx.secteurActivite,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.secteurActivite) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Secteur d'activité"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "secteurActivite",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-3" }, "Produits/Services proposés", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "numbered-input mb-2",
                "data-number": `${index + 1}.`
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Field, {
                    name: `produit${index + 1}`,
                    modelValue: produit.value,
                    "onUpdate:modelValue": ($event: any) => ((produit.value) = $event),
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: `Produit/Service ${index + 1}`
                  }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "placeholder"]),
                  (_ctx.produits.length > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeProduit(index)),
                        class: "btn btn-outline-danger ms-2"
                      }, [...(_cache[28] || (_cache[28] = [
                        _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                      ]))], 8, _hoisted_25))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_23))
            }), 128)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addProduit && _ctx.addProduit(...args))),
              class: "btn btn-outline-primary btn-sm"
            }, [...(_cache[29] || (_cache[29] = [
              _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
              _createTextVNode("Ajouter un produit/service ", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Ancienneté dans l'activité (années) ", -1)),
                _createVNode(_component_Field, {
                  name: "anciennete",
                  modelValue: _ctx.anciennete,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.anciennete) = $event)),
                  type: "number",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Nombre d'années",
                  min: "0"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "anciennete",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " N° de l'étalage ou boutique ", -1)),
                _createVNode(_component_Field, {
                  name: "numeroEtalage",
                  modelValue: _ctx.numeroEtalage,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.numeroEtalage) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Numéro d'étalage"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "numeroEtalage",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-3" }, "Êtes-vous inscrit sur la liste SOGEMA-Liquidation ?", -1)),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_Field, {
                name: "sogemaLiquidation",
                value: "oui",
                type: "radio",
                class: "form-check-input",
                id: "sogemaOui"
              }),
              _cache[33] || (_cache[33] = _createElementVNode("label", {
                class: "form-check-label",
                for: "sogemaOui"
              }, "Oui", -1))
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_Field, {
                name: "sogemaLiquidation",
                value: "non",
                type: "radio",
                class: "form-check-input",
                id: "sogemaNon"
              }),
              _cache[34] || (_cache[34] = _createElementVNode("label", {
                class: "form-check-label",
                for: "sogemaNon"
              }, "Non", -1))
            ]),
            _createVNode(_component_ErrorMessage, {
              name: "sogemaLiquidation",
              class: "text-danger d-block"
            })
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[40] || (_cache[40] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-3" }, "Type d'installation", -1)),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_Field, {
                    name: "typeInstallation",
                    value: "boutique",
                    type: "checkbox",
                    class: "form-check-input",
                    id: "boutiqueConstruite"
                  }),
                  _cache[36] || (_cache[36] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "boutiqueConstruite"
                  }, "Boutique construite", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_Field, {
                    name: "typeInstallation",
                    value: "kiosque",
                    type: "checkbox",
                    class: "form-check-input",
                    id: "kiosque"
                  }),
                  _cache[37] || (_cache[37] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "kiosque"
                  }, "Kiosque", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_Field, {
                    name: "typeInstallation",
                    value: "table",
                    type: "checkbox",
                    class: "form-check-input",
                    id: "tableEtalage"
                  }),
                  _cache[38] || (_cache[38] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "tableEtalage"
                  }, "Table/étalage", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_Field, {
                    name: "typeInstallation",
                    value: "ambulant",
                    type: "checkbox",
                    class: "form-check-input",
                    id: "ambulant"
                  }),
                  _cache[39] || (_cache[39] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "ambulant"
                  }, "Ambulant", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _cache[43] || (_cache[43] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-3" }, "Type de marchand", -1)),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_Field, {
                name: "typeMarchand",
                value: "locataire",
                type: "radio",
                class: "form-check-input",
                id: "locataire"
              }),
              _cache[41] || (_cache[41] = _createElementVNode("label", {
                class: "form-check-label",
                for: "locataire"
              }, "Locataire", -1))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_Field, {
                name: "typeMarchand",
                value: "exploitant",
                type: "radio",
                class: "form-check-input",
                id: "exploitant"
              }),
              _cache[42] || (_cache[42] = _createElementVNode("label", {
                class: "form-check-label",
                for: "exploitant"
              }, "Exploitant", -1))
            ]),
            _createVNode(_component_ErrorMessage, {
              name: "typeMarchand",
              class: "text-danger d-block"
            })
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _cache[44] || (_cache[44] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Nombre de personnes travaillant avec vous ", -1)),
              _createVNode(_component_Field, {
                name: "nombrePersonnes",
                modelValue: _ctx.nombrePersonnes,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.nombrePersonnes) = $event)),
                type: "number",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Nombre de personnes",
                min: "0"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "nombrePersonnes",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _cache[47] || (_cache[47] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-3" }, "Lien avec associations/coopératives", -1)),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_Field, {
                    name: "lienAssociation",
                    value: "oui",
                    type: "radio",
                    class: "form-check-input",
                    id: "assocOui",
                    onChange: _ctx.toggleAssociationInput
                  }, null, 8, ["onChange"]),
                  _cache[45] || (_cache[45] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "assocOui"
                  }, "Oui (préciser)", -1))
                ]),
                _createVNode(_component_Field, {
                  name: "precisionAssociation",
                  modelValue: _ctx.precisionAssociation,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.precisionAssociation) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black mt-2",
                  placeholder: "Précisez l'association/coopérative",
                  disabled: !_ctx.showAssociationInput
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_Field, {
                    name: "lienAssociation",
                    value: "non",
                    type: "radio",
                    class: "form-check-input",
                    id: "assocNon",
                    onChange: _ctx.toggleAssociationInput
                  }, null, 8, ["onChange"]),
                  _cache[46] || (_cache[46] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "assocNon"
                  }, "Non", -1))
                ])
              ])
            ]),
            _createVNode(_component_ErrorMessage, {
              name: "lienAssociation",
              class: "text-danger d-block"
            })
          ]),
          _createElementVNode("div", _hoisted_55, [
            _cache[50] || (_cache[50] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-3" }, "Besoins", -1)),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_Field, {
                    name: "besoins",
                    value: "boutique",
                    type: "checkbox",
                    class: "form-check-input",
                    id: "besoinBoutique"
                  }),
                  _cache[48] || (_cache[48] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "besoinBoutique"
                  }, "Boutique", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_Field, {
                    name: "besoins",
                    value: "stand",
                    type: "checkbox",
                    class: "form-check-input",
                    id: "besoinStand"
                  }),
                  _cache[49] || (_cache[49] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "besoinStand"
                  }, "Stand", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_Field, {
                  name: "autresBesoin",
                  modelValue: _ctx.autresBesoin,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.autresBesoin) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Autres besoins"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _cache[53] || (_cache[53] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-3" }, "Souhaitez-vous la mutualisation ?", -1)),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(_component_Field, {
                    name: "mutualisation",
                    value: "oui",
                    type: "radio",
                    class: "form-check-input",
                    id: "mutualOui",
                    onChange: _ctx.toggleMutualisationInput
                  }, null, 8, ["onChange"]),
                  _cache[51] || (_cache[51] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "mutualOui"
                  }, "Oui (préciser)", -1))
                ]),
                _createVNode(_component_Field, {
                  name: "precisionMutualisation",
                  modelValue: _ctx.precisionMutualisation,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.precisionMutualisation) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black mt-2",
                  placeholder: "Précisez le type de mutualisation",
                  disabled: !_ctx.showMutualisationInput
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_Field, {
                    name: "mutualisation",
                    value: "non",
                    type: "radio",
                    class: "form-check-input",
                    id: "mutualNon",
                    onChange: _ctx.toggleMutualisationInput
                  }, null, 8, ["onChange"]),
                  _cache[52] || (_cache[52] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "mutualNon"
                  }, "Non", -1))
                ])
              ])
            ]),
            _createVNode(_component_ErrorMessage, {
              name: "mutualisation",
              class: "text-danger d-block"
            })
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _cache[54] || (_cache[54] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Observations de l'agent recenseur ", -1)),
              _createVNode(_component_Field, {
                name: "observations",
                modelValue: _ctx.observations,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.observations) = $event)),
                as: "textarea",
                class: "form-control shadow-none fs-md-15 text-black",
                rows: "4",
                placeholder: "Notez ici vos observations..."
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "observations",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _cache[55] || (_cache[55] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                  _createTextVNode(" Date du recensement "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateRecensement",
                  modelValue: _ctx.dateRecensement,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dateRecensement) = $event)),
                  type: "date",
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateRecensement",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _cache[56] || (_cache[56] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Signature de l'agent recenseur ", -1)),
                _createVNode(_component_Field, {
                  name: "signatureAgent",
                  modelValue: _ctx.signatureAgent,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.signatureAgent) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Nom complet pour signature"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "signatureAgent",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            _cache[58] || (_cache[58] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-3" }, "Documents justificatifs", -1)),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createVNode(_component_DropZone, {
                  name: "fichiers[]",
                  maxFilesize: 50,
                  maxFiles: 30,
                  uploadOnDrop: true,
                  onAddedFile: _ctx.onFileAdd,
                  onRemovedFile: _ctx.onFileRemove,
                  options: _ctx.dropzoneOptions,
                  onVdropzoneSuccess: _ctx.onSuccess,
                  onVdropzoneError: _ctx.onError
                }, {
                  default: _withCtx(() => [
                    (!_ctx.hasFiles)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _createElementVNode("img", {
                            src: _ctx.defaultImage,
                            alt: "Default",
                            class: "default-image"
                          }, null, 8, _hoisted_79),
                          _cache[57] || (_cache[57] = _createElementVNode("p", null, "Glissez et déposez ici vos documents", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onAddedFile", "onRemovedFile", "options", "onVdropzoneSuccess", "onVdropzoneError"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_PDFGeneratorSimple, {
              "form-data": _ctx.getFormData(),
              "form-ref": _ctx.recensementForm
            }, null, 8, ["form-data", "form-ref"]),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary btn-lg me-3",
              disabled: _ctx.isSubmitting
            }, [
              (_ctx.isSubmitting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_82))
                : _createCommentVNode("", true),
              (!_ctx.isSubmitting)
                ? (_openBlock(), _createElementBlock("i", _hoisted_83))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Enregistrement...' : 'Enregistrer le recensement'), 1)
            ], 8, _hoisted_81),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
              class: "btn btn-secondary btn-lg"
            }, [...(_cache[59] || (_cache[59] = [
              _createElementVNode("i", { class: "fas fa-undo me-2" }, null, -1),
              _createTextVNode("Réinitialiser ", -1)
            ]))])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}